import TemplateEditor from "../../Template-Management/Template-Editor/template-editor";
import { useState } from "react";

export default function EditorModal({
  contract,
  content,
  setContent,
  onClose,
  onSave,
  isBlank,isEdit
}) {
  const [modal, setModal] = useState(null);
  console.log("🚀 ~ file: editor-modal.js:10 ~ EditorModal ~ contract:", contract);
    console.log("🚀 ~ file: editor-modal.js:10 ~ EditorModal ~ content:", content);

  return (
    <Modal
      title={contract?.title || "Contract Editor"}
     /// title="Oak Residency Lease"
      className="max-w-6xl"
      onClose={() => onClose()}
    >
      <div className="  text-sm text-gray-700 leading-relaxed whitespace-pre-line">
        <TemplateEditor
          content={contract?.document_content || content}
          onChange={setContent}
          isBlank={isBlank}
          onSave={onSave}
          contractName={contract?.title}
          isEdit={isEdit}
        />
      </div>

    </Modal>
  );
}

function Modal({ title, children, onClose, className = "" }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div
        className={`
          bg-white rounded-xl shadow-xl w-full max-w-4xl h-[80vh] flex flex-col
          ${className}
        `}
      >
        {/* Header (fixed) */}
        <div className="flex justify-between items-center p-4 border-b shrink-0">
          <h2 className="font-semibold">{title}</h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Body (scrollable) */}
        <div className="p-4 flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}